<template>
  <div class="connection-text-container" :class="device.isMobile ? 'connection-text-container-mobile' : ''" :id="content.key">
    <div class="action-title">{{ content.title }}</div>
    <div class="reset" @click.stop="reset"></div>
    <div class="action-content">
      <div class="action-item" v-for="(item, index) in resultData" :key="item.key">
        <template v-for="(text, idx) in item.answerContent">
          <span v-if="text.type === 'text'" :key="idx">{{ text.text }}</span>
          <span v-if="text.type === 'input'" :key="idx" class="action-input">
            <draggable
              :key="index"
              class="action-handle"
              :sort="false"
              :disabled="false"
              :group="{
                name: content.key,
                pull: false,
                put: dropChecked(item)
              }"
              @add="dropHandle($event, item, index)"
              v-model="item.newArr"
            >
              <div class="" v-for="(it, idx) in item.newArr" :key="idx">
                <span>{{ it.actionLabel }}</span>
              </div>
            </draggable>
          </span>
        </template>
      </div>
    </div>
    <draggable
      class="action-bottom-handle"
      :sort="false"
      :group="{
        name: content.key,
        pull: true,
        put: false
      }"
      @start="dragstartHandle($event)"
      v-model="handleData"
    >
      <template v-for="item in handleData">
        <div
          :key="item.key"
          v-if="!item.hideInHandle"
          class="action-handle-item"
        >{{ item.actionLabel }}</div>
      </template>
    </draggable>
  </div>
</template>

<script>
/*
文字拖拽填空组件
*/
import draggable from "vuedraggable";
import { getActionData, setActionData } from "@/utils/storage";
export default {
  name: "connectionText",
  components: {
    draggable
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      resultData: [],
      handleData: [],
      historyData: null,
    }
  },
  mounted() {
    this.historyData = (JSON.parse(getActionData()) || {})
    let historyData = this.historyData[this.content.key]

    this.resultData = this.content.content.leftData.map((item, index) => {
      let returnData = item;
      let rightData = this.content.content.rightData.find(right => {
        return right.answerKey == item.answerKey
      });
      returnData = JSON.parse(JSON.stringify(returnData))
      returnData.mark = 'left'
      returnData.newArr = []
      if(historyData && historyData[index]) {
        returnData.mark = 'right'
        returnData.isTrue = 1
        returnData.newArr.push(rightData)
      }
      return returnData
    })
    this.handleData = this.content.content.rightData.filter(item => {
      return !(historyData && historyData.includes(item.key))
    });
    console.log('1111111111111', this.resultData, this.handleData)
  },
  methods: {
    dragstartHandle(e) {
      let handleData = this.handleData[e.oldIndex];
      this.dragKey = handleData.answerKey;
      this.dragIndex = e.oldIndex;
    },
    dropChecked(item) {
      if(item.newArr.length > 0) return false;
      return true
    },
    dropHandle(event, item, index) {
      let handleIndex = this.dragIndex
      let resultIndex = index

      if(this.resultData[resultIndex].newArr[0].answerKey !== this.resultData[resultIndex].answerKey) {
        let changeData = this.resultData[resultIndex].newArr[0]
        this.$set(this.resultData[resultIndex], 'newArr', [])
        this.handleData.splice(handleIndex, 0, changeData)
        this.$forceUpdate()
        return false
      }

      // this.$set(this.handleData[handleIndex], 'hideInHandle', true)
      this.$set(this.resultData[resultIndex], 'mark', 'right')
      this.$set(this.resultData[resultIndex], 'isTrue', 1)
      
      
      let historyData = {}
      historyData[this.content.key] = this.resultData.map(result => (result.newArr[0] || {}).key);
      this.historyData = Object.assign({}, this.historyData, historyData)
      setActionData(JSON.stringify(this.historyData));
    },
    // 重置整个内容
    reset() {
      this.handleData = this.content.content.rightData.map(item => {
        item.hideInHandle = false
        return item
      });
      this.resultData = this.content.content.leftData.map(item => {
        // item = {}
        item.mark = 'left'
        item.newArr = []
        item.isTrue = 0
        return item
      })
      
      delete this.historyData[this.content.key]
      setActionData(JSON.stringify(this.historyData));
    },
  }
}
</script>

<style lang="scss" scoped>
.connection-text-container{
  border: 1rem solid #E3E3E3;
  border-radius: 10rem;
  margin: 0 !important;
  width: 100% !important;
  padding: 25rem 20rem 15rem;
  position: relative;

  .action-title{
    font-size: 28rem;
    line-height: 44rem;
    color: #333;
    font-weight: bold;
    font-family: Arial;
    margin-bottom: 42rem;
  }

  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: 66rem;
    right: 10rem;
    cursor: pointer;
    z-index: 5;
  }

  .action-content{
    .action-item{
      margin-bottom: 20rem;
      font-family: Calibri;
      color: #333;
      font-size: 28rem;
      line-height: 36rem;

      span{
        border-bottom: 1rem solid transparent;
      }

      .action-input{
        width: 150rem;
        display: inline-block;
        border-bottom: 1rem solid #333;
        vertical-align: bottom;
        text-align: center;
        color: #5CA683;
        font-weight: bold;
      }
    }
  }

  .action-bottom-handle{
    margin: 0 -10rem;
    padding: 23rem 30rem 0;
    background: #EAF4F0;
    display: flex;
    flex-wrap: wrap;
    min-height: 140rem;

    .action-handle-item{
      font-size: 28rem;
      line-height: 32rem;
      color: #5CA683;
      font-weight: bold;
      margin-right: 40rem;
      font-family: Calibri;
      margin-bottom: 26rem;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.connection-text-container-mobile{
  .reset{
    width: 44rem;
    height: 44rem;
  }
}
</style>